import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalDialogComponent } from '@k12/ui-primitives';

export interface ConsentFormResult {
  informationConsent: boolean;
  credentialReleaseConsent: boolean;
  isEditMode?: boolean;
};

@Component({
  selector: 'lib-consent-form',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule
  ],
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent {

  private readonly dialogData = inject(MAT_DIALOG_DATA) as { consentFormData: ConsentFormResult };
  private readonly dialogRef = inject(MatDialogRef<ModalDialogComponent>);
  private readonly formbuilder = inject(FormBuilder);

  consentForm: FormGroup = this.formbuilder.group({
    informationConsent: [
      this.dialogData?.consentFormData?.informationConsent ?? false,
      [Validators.requiredTrue]
    ],
    credentialReleaseConsent: [
      this.dialogData?.consentFormData?.credentialReleaseConsent ?? false,
      [Validators.requiredTrue]
    ]
  });

  public readonly isEditMode = this.dialogData?.consentFormData?.isEditMode === true;

  onCancelConsentForm(): void {
    this.dialogRef.close();
  }

  onSubmitConsentForm(): void {
    const result = this.consentForm.getRawValue() as ConsentFormResult;
    this.dialogRef.close(result);
  }
}
